// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---GwGpV","changedRecordsList":"changedRecordsList---Kz8MF","changedRecord":"changedRecord---ibITv"};